"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ChosenMark = _interopRequireDefault(require("web/shared/imageCandidates/ChosenMark"));
var _ImageCandidateIconButton = _interopRequireDefault(require("web/shared/imageCandidates/ImageCandidateIconButton"));
var _ImageCandidateActions = require("web/shared/imageCandidates/ImageCandidateActions.styles");
var _imageCandidateWording = require("web/shared/imageCandidates/imageCandidateWording");
var _toast = require("web/shared/utils/toast");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* What can be done to a candidate: choose it (or the mark saying it is
* chosen), view it full screen where there is a view to open, and delete
* it. Choosing answers on the spot, before the server does. A delete the
* rules forbid stays tappable so the tap can say why, as a toast.
*/ // Why a candidate cannot be deleted, or null when it can. A protected only
// candidate is also the chosen one, so it is refused for that reason.
function deleteReasonFor(candidate, only, cannotDeleteChosen) {
  if (candidate.selection === "CHOSEN" || only) {
    return cannotDeleteChosen;
  }
  return null;
} // The icon action between the choose control and the trash, where the
// picture has a view to open: what it draws, what it is called, and what it
// does.
function ImageCandidateActions(props) {
  const candidate = props.candidate,
    choosing = props.choosing;
  const wording = (0, _imageCandidateWording.useImageCandidateWording)();
  const chosen = candidate.selection === "CHOSEN" || choosing;
  const deleteReason = deleteReasonFor(candidate, props.only, wording.cannotDeleteChosen);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ImageCandidateActions.styles.row)), {}, {
    children: [chosen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChosenMark.default, {
      drawIn: choosing
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
      type: "button",
      disabled: props.busy,
      onClick: () => {
        props.onChoose();
      }
    }, stylex.props(_ImageCandidateActions.styles.action)), {}, {
      children: wording.chooseLabel
    })), props.view == null ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateIconButton.default, {
      name: props.view.name,
      label: props.view.label,
      title: props.view.title,
      kind: "view",
      motion: "cycle",
      blocked: false,
      disabled: props.busy,
      onPress: props.view.onPress
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageCandidateIconButton.default, {
      name: "trash",
      label: "Delete",
      title: deleteReason !== null && deleteReason !== void 0 ? deleteReason : wording.deleteTitle,
      kind: "delete",
      motion: "cycle",
      blocked: deleteReason != null,
      disabled: props.busy,
      onPress: () => {
        if (deleteReason == null) {
          props.onDelete();
        } else {
          (0, _toast.showToast)(deleteReason);
        }
      }
    })]
  }));
}
var _default = exports.default = ImageCandidateActions;